import { render } from "./how_to_use_admin.vue?vue&type=template&id=72e3240b&scoped=true"
import script from "./how_to_use_admin.vue?vue&type=script&lang=js"
export * from "./how_to_use_admin.vue?vue&type=script&lang=js"

import "./how_to_use_admin.vue?vue&type=style&index=0&id=72e3240b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e3240b"]])

export default __exports__